import { environment } from '../../../environments/environment';

/**
 * Where the API is and what this app may call its browser-storage keys.
 *
 * 034 T016: this was an Angular `InjectionToken`. React has no injector, so it is a module-level
 * value — but the two properties the token was chosen for are kept deliberately, because both are
 * requirements rather than style:
 *
 *   - **No URL is written at a call site** (005 FR-005). Everything goes through `apiUrl()`, which
 *     reads this.
 *   - **A test can substitute it.** `setAppConfig` exists for that and for nothing else; the
 *     session harness calls it, application code never does. Module state is per test FILE under
 *     Vitest, so one spec's override cannot leak into another's — which is the isolation the
 *     injector used to provide.
 */
export interface AppConfig {
  readonly apiBaseUrl: string;
  readonly storagePrefix: string;
}

let current: AppConfig = {
  apiBaseUrl: environment.apiBaseUrl,
  storagePrefix: environment.storagePrefix,
};

export const appConfig = (): AppConfig => current;

/** Test seam. Production code reads `appConfig()` and never calls this. */
export function setAppConfig(config: AppConfig): void {
  current = config;
}
